module.exports = __webpack_public_path__ + "img/animals_cat2.34d82e43.png";